import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockTransferService = {
  getAllStockTransferList,
  getStockTransferList,
  saveStockTransfer,
  getStockTransferDetail,
  saveStockTransferExcel,
  exportAllStockTransferExcel,
  getStockTransferExcelTemplate
};

function getStockTransferList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromWarehouseId) {
    params["fromWarehouseId"] = searchParams.fromWarehouseId;
  }
  if (searchParams.toWarehouseId) {
    params["toWarehouseId"] = searchParams.toWarehouseId;
  }
  if (searchParams.issueDate) {
    params["issueDate"] = searchParams.issueDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }

  return axios.get("/auth/stock-transfers", { params });
}

function getAllStockTransferList(searchParams) {
  let params = {
    sort: "fromWarehouseName,asc"
  };
  if (searchParams.fromWarehouseId) {
    params["fromWarehouseId"] = searchParams.fromWarehouseId;
  }
  if (searchParams.toWarehouseId) {
    params["toWarehouseId"] = searchParams.toWarehouseId;
  }
  if (searchParams.issueDate) {
    params["issueDate"] = searchParams.issueDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  return axios.get("/auth/stock-transfers", { params });
}

function saveStockTransfer(stockTransfer) {
  if (!stockTransfer.id) {
    // new stockTransfer
    return axios.post("/auth/stock-transfer", stockTransfer);
  } else {
    // edit
    return axios.put("/auth/stock-transfer", stockTransfer);
  }
}

function getStockTransferDetail(id) {
  return axios.get("/auth/stock-transfer/" + id);
}

function saveStockTransferExcel(file) {
  return axios.post('/auth/stock-transfer-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function exportAllStockTransferExcel(searchParams) {
  let params = {
  };
  if (searchParams.fromWarehouseId) {
    params["fromWarehouseId"] = searchParams.fromWarehouseId;
  }
  if (searchParams.toWarehouseId) {
    params["toWarehouseId"] = searchParams.toWarehouseId;
  }
  if (searchParams.issueDate) {
    params["issueDate"] = searchParams.issueDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/stock-transfer-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getStockTransferExcelTemplate() {

  return orginal_axios({
      method: "GET",
      url: axios.defaults.baseURL + "/auth/stock-transfer-excel-template",
      responseType: "arraybuffer", // important
      headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
  }).then(function (response) {
      return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}
